import config from '../../../../../config';
import Request from '../../../../Request';

export default function update(reservationId, questionId, answerId, values, onSuccess, onFailure) {
  return Request.patch(
    `${config.apiUrl}/reservations/${reservationId}/reservation_questions/${questionId}/reservation_answers/${answerId}`,
    { reservation_answer: values },
    onSuccess,
    onFailure
  );
}